/**
 * Template config — add a new entry here to create a new template.
 * Each template defines visual tokens used by TemplateProvider and
 * individual pages via useTemplate().
 *
 * Pages that only need colour/background changes need zero code changes —
 * the TemplateProvider applies pageBg automatically.
 *
 * Pages that need a full layout redesign (e.g. the dashboard) use a
 * separate component file and switch on user.dashboardTemplate themselves.
 */

export const TEMPLATES = {
  1: {
    id:       1,
    name:     'Default',
    pageBg:   null,          // use MUI theme default
    cardBg:   '#FFFFFF',
    border:   '#E0E0E0',
    ink:      null,          // use theme default
    sub:      null,
    accent:   null,          // use theme primary
  },

  2: {
    id:       2,
    name:     'Light',
    pageBg:   '#F4F3F0',     // warm cream — applied to the full scroll area
    cardBg:   '#FFFFFF',
    border:   '#E6E5E2',
    ink:      '#111111',
    sub:      '#6B6B6B',
    ghost:    '#ADADAD',
    accent:   '#5B21B6',
    accentBg: '#EDE9FE',
    green:    '#16A34A',
    greenBg:  '#F0FDF4',
    red:      '#DC2626',
    redBg:    '#FEF2F2',
    amber:    '#B45309',
    amberBg:  '#FFFBEB',
  },

  3: {
    id:       3,
    name:     'White',
    pageBg:   '#FFFFFF',
    cardBg:   '#FFFFFF',
    border:   '#E4E4E7',
    ink:      '#09090B',
    sub:      '#52525B',
    ghost:    '#A1A1AA',
    accent:   '#7C3AED',
    accentBg: '#F5F3FF',
    green:    '#16A34A',
    greenBg:  '#F0FDF4',
    red:      '#DC2626',
    redBg:    '#FEF2F2',
    amber:    '#D97706',
    amberBg:  '#FFFBEB',
  },

  // Template 4, 5… just add entries here.
};

export const getTemplate = (id) => TEMPLATES[id] ?? TEMPLATES[1];
